type Options = {
  defaultValue?: boolean;
};

export const toBoolean = (
  // eslint-disable-next-line
  data: any,
  { defaultValue }: Options = {}
): boolean => {
  if (data !== 'oui' && data !== 'non') {
    return !!defaultValue;
  }

  return data === 'oui';
};

export const toBooleanFromProp = (
  propName: string,
  // eslint-disable-next-line
  data: any,
  options: Options = {}
): boolean => toBoolean(data?.[propName], options);
